module.exports = __webpack_public_path__ + "static/Functional_Units-PURIFINES_Washing_System_s-ad2df91e88445afca0ba882807926410.png";